import { useMemo } from 'react';
import { format } from 'date-fns';
import { useQuery } from '@apollo/client';
import { useInstallationContext } from '../../../../../../../context/installation';
import {
  BucketInfo,
  DynamicMarketPricesWithBucketsQueryVariables,
  Query,
} from '../../../../../../../data-access/gql-types/graphql';
import { DYNAMIC_MARKET_PRICES_WITH_BUCKETS } from '../../../../../../../data-access/queries/meter';
import { getHeatmapColor } from '../../../../common/tariff/utils';
import { DashboardPrice } from '../../../types/types';
import { DashboardTariffHours } from '../tariff-hours';

export const DynamicHours: React.FC = () => {
  const { skipLavvaFetch } = useInstallationContext();
  const { data, loading } = useQuery<Query, DynamicMarketPricesWithBucketsQueryVariables>(
    DYNAMIC_MARKET_PRICES_WITH_BUCKETS,
    {
      skip: skipLavvaFetch,
    },
  );

  const dynamicPrices: DashboardPrice[] = useMemo(() => {
    const currentHour = new Date().getHours();
    const prices = [...(data?.dynamicMarketPricesWithBuckets.days || [])].reverse();

    const index = prices.findIndex((x) => x.day === format(new Date(), 'yyyy-MM-dd'));

    if (index !== -1) {
      const bucketInfos = data?.dynamicMarketPricesWithBuckets.bucketInfos as BucketInfo[] | null;

      const dashboardPrices: DashboardPrice[] = prices[index].records
        .filter((x) => x.startingHour >= currentHour)
        .map((x) => ({
          startingHour: x.startingHour,
          color: getHeatmapColor(x.priceInkWh, bucketInfos),
        }));

      if (index < prices.length - 1) {
        return [
          ...dashboardPrices,
          ...prices[index + 1].records.slice(0, currentHour).map((x) => ({
            startingHour: x.startingHour,
            color: getHeatmapColor(x.priceInkWh, bucketInfos),
          })),
        ];
      } else {
        return [...dashboardPrices];
      }
    }

    return [];
  }, [data?.dynamicMarketPricesWithBuckets.days]);

  return <DashboardTariffHours prices={dynamicPrices} loading={loading} />;
};
